import React from "react";
// import PropTypes from "prop-types";
import styles from "./index.module.css";

const Banner = () => (
  <div className={styles.root}>
    <span className={styles.text}>
      The State of European Tech 2018 is now live
    </span>
    <a
      href="https://2018.stateofeuropeantech.com"
      className={styles.button}
      target="_blank"
      rel="noopener noreferrer"
    >
      View 2018 report
    </a>
  </div>
);

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner/index.js